import React, { useEffect } from "react";
import "../../../style/donors/pastDonor.css";
import Footer from "../../shared/Footer/Footer";
import Navbar from "../../shared/Navbar/Navbar";
import governmentLogo from "../../../images/Logo/GOB.png";
import "../../../style/donors/currentDonor.css";
import Zoom from "react-reveal/Zoom";
import TranslateButton from "../../TranslateButton/TranslateButton";
import {
  FacebookIcon,
  FacebookShareButton,
  TwitterShareButton,
  TwitterIcon,
  LinkedinShareButton,
  LinkedinIcon,
} from "react-share";

const CurrentDonor = () => {
  useEffect(() => {
    document.title = `Development Concern | Current Donor`;
  }, []);

  // const shareUrl = "https://developmentconcerncht.org/donors/current-donor-ict";

  return (
    <div>
      <Navbar />
      {/* <TranslateButton /> */}

      <div className="current_donor_section">
        <div className="header_image">
          <p>Home | Donor</p>
          <h2>Current Donor</h2>
        </div>

        {/* Header Background Part Start */}
        {/* <div className="header_background">
          <div className="container wrapper">
            <h2>ict</h2>
            <div className="social_share_button">
              <FacebookShareButton
                url={shareUrl}
                target={"_blank"}
                quote={"share facebook"}
                hashtag={"#facebook"}
              >
                <FacebookIcon size={35} round={true} />
              </FacebookShareButton>
              <TwitterShareButton
                url={shareUrl}
                target={"_blank"}
                quote={"share twitter"}
                hashtag={"#twitter"}
              >
                <TwitterIcon size={35} round={true} />
              </TwitterShareButton>
              <LinkedinShareButton
                url={shareUrl}
                target={"_blank"}
                quote={"share linkedin"}
                hashtag={"#linkedin"}
              >
                <LinkedinIcon size={35} round={true} />
              </LinkedinShareButton>
            </div>
          </div>
        </div> */}
        {/* Header Background Part End */}

        <div className="container">
          <h1>Current Donor</h1>
          <div className="content_wrapper">
            <Zoom duration={2000}>
              <div className="singal_wrapper">
                <img src={governmentLogo} alt="" />
                <p>Information & Communication Technology</p>
              </div>
            </Zoom>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default CurrentDonor;
